import moment from "moment";
import React, { useEffect } from "react";
import { getEvent } from "../apiDefault/events";

// Check if the event is in the future or not to unlock link connect-day    
export default function useCheckEvent() {
  const [isEvent, setIsEvent] = React.useState(false);

  async function getInfoEvent() {
    const response = await getEvent();

    if (response.length === 0) {
      setIsEvent(false);
      return;
    }

    // FORMAT DATE AND DAY FOR THE FUTURE EVENT
    const date = new Date(response[0]?.date);
    const formattedDate = new Date(
      date.setHours(23, 59)
    );
    setIsEvent(new Date() < formattedDate );
  }

  useEffect(() => {
    getInfoEvent();
  }, []);
  
  return {
    isEvent
  };
}
